export enum UserRole {
    CUSTOMER = 'CUSTOMER',
    COURIER = 'COURIER',
    ADMIN = 'ADMIN',
    DEPO = 'DEPO',
}
